import { useEffect } from "react";
import { shallow } from "zustand/shallow";
import { useWebUserStore } from "../../../../../../CommonStores";
import PaymentDrawTonightInterfaceStore from "../../interface/PaymentDrawTonightInterface";

const useUserAndEntriesSync = () => {
  const [user, totalEntries] = useWebUserStore(
    (store) => [store.user, store.totalEntries],
    shallow
  );

  useEffect(() => {
    const { setUser, setTotalEntries } =
      PaymentDrawTonightInterfaceStore.getState();
    setUser(user ?? undefined);
    setTotalEntries(totalEntries ?? 0);
  }, [user, totalEntries]);
};

export default useUserAndEntriesSync;
